export const AusPostIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = "#dc1928" } = props;

  return (
    <svg
      fill={fill}
      width={width}
      height={height}
      viewBox="0 0 14 14"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m 6.9813042,1.0368865 c -0.1475452,0 -0.2583724,0 -0.4062544,0 l 0,0.627908 c 0.073772,0 0.1475451,0 0.2587092,0 2.0305982,0 3.729051,1.661399 3.729051,3.691997 0,2.030935 -1.6617349,3.691997 -3.6919963,3.729052 l 0,3.8772695 c 0.036718,0 0.073773,0 0.1108273,0 C 10.304775,12.963113 13,10.30427 13,6.9811355 12.999663,3.6953935 10.304438,1.0368865 6.9813042,1.0368865 l 0,0 z m -1.7351711,0.258709 c -2.4739075,0.738399 -4.24613325,2.990652 -4.24613325,5.68554 0,2.73228 1.77222575,4.9845335 4.24613325,5.7232695 l 0,-11.4088095 0,0 z" />
    </svg>
  );
};
